import React, { FC } from 'react';
import ReactHelmet from 'react-helmet';
import {PageProps} from "gatsby";
import {useI18next} from "gatsby-plugin-react-i18next";

interface Props {
  title: string;
  description: string;
  windowLocation: PageProps['location'];
}

const Seo: FC<Props> = ({ title, description, children, windowLocation }) => {

    const {languages, language: currentLang} = useI18next();

    console.log(windowLocation);

    return(
        <ReactHelmet
            title={title}
            meta={[
                {
                    name: 'description',
                    content: description,
                },
            ]}
        >
            {languages.map(language => (
                <link key={language} rel='alternate' hrefLang={language} href={`${windowLocation.origin}${language === "en" ? "" : `/${language}`}${windowLocation.pathname === "/" ? "" : `${windowLocation.pathname.replace(`/${currentLang}`, "")}`}`}/>
            ))}
            {children}
        </ReactHelmet>
    )
};

export default Seo;
